import { get, find, remove, pullAll, isEmpty, extend } from 'lodash';
import getContent from '../lib/dictionaryFetcher';

const PP_SHOPPING_CARD = 'pp_third_party_shopping_card',
  US = 'US',
  GB = 'gb';

export const getCategories = state => {
  const otss = get(state, 'app.context.user.eligibility.otss', []),
    externalTool = get(state, 'app.context.user.eligibility.tools', {}),
    isGB = get(state, 'app.context.locale.country', US).toLowerCase() === GB,
    experiment = get(state, 'experimentation', {}),
    inOnBuyGBExperiment = get(experiment, 'onbuy', false),
    inWishExperiment = get(experiment, 'wish', false);

  let categories = get(state, 'metadata.categories', []),
    selling = find(categories, { name: 'selling' }),
    business = find(categories, { name: 'business' });

  // for OnBuy ramp, remove when done
  if (isGB && !inOnBuyGBExperiment) {
    if (selling) {
      selling.items = [PP_SHOPPING_CARD];
    }
    if (business && get(business, 'items', []).length) {
      remove(business.items, item => item === PP_SHOPPING_CARD);
    }
  } else if (!inWishExperiment) {
    pullAll(selling.items, ['wish']);
  } else if (otss.length && get(selling, 'items', []).length) {
    pullAll(selling.items, otss);
  }

  if (!isEmpty(externalTool) && !business.items.includes(externalTool.name)) {
    business.items.push(externalTool.name);
  }

  return categories;
};

export const getTools = state => {
  let tools = get(state, 'myapps.tools', {}),
    externalTool = get(state, 'app.context.user.eligibility.tools', {});

  if (!isEmpty(externalTool)) {
    tools[externalTool.name] = {
      name: getContent('merchanthub', `apps.${externalTool.name}.title`, ''),
      description: getContent(
        'merchanthub',
        `apps.${externalTool.name}.description`,
        ''
      ),
      favorite: false,
      active: true,
      key: externalTool.name,
      link: externalTool.link,
      type: 'tool',
      external: true
    };
  }

  return tools;
};

export const getFeatured = state => {
  const otss = get(state, 'app.context.user.eligibility.otss', []),
    experiment = get(state, 'experimentation', {}),
    inOnBuyGBExperiment = get(experiment, 'onbuy', false),
    inWishRampExperiment = get(experiment, 'wish', false),
    inMarketplacesExperiment = get(experiment, 'marketplaces', false);

  let featured = {};

  if (otss.length) {
    if (otss.includes('grailed')) {
      extend(featured, { selling: 'grailed' });
    } else if (otss.includes('swappa')) {
      extend(featured, { selling: 'swappa' });
    } else if (otss.includes('bonanza')) {
      extend(featured, { selling: 'bonanza' });
    } else if (otss.includes('hood')) {
      extend(featured, { selling: 'hood' });
      // For OnBuy ramp, remove exp check when done
    } else if (otss.includes('onbuy') && inOnBuyGBExperiment) {
      extend(featured, { selling: 'onbuy' });
    } else if (otss.includes('wish') && inWishRampExperiment) {
      extend(featured, { selling: 'wish' });
    }
  }
  // Specific for Marketplaces
  // REMINDER: Cleanup by making bigcommerce as featured all the time
  if (inMarketplacesExperiment) {
    extend(featured, { shoppingcarts: 'bigcommerce' });
  }
  return featured;
};
